import {
  AppTrackingStatusResponse,
  AppTrackingTransparency,
} from 'capacitor-plugin-app-tracking-transparency';
import { isIosApp } from 'utils/platform';

const getAppTrackingStatus = async (): Promise<AppTrackingStatusResponse> => {
  return await AppTrackingTransparency.getStatus();
};

const requestAppTrackingPermission =
  async (): Promise<AppTrackingStatusResponse> => {
    return await AppTrackingTransparency.requestPermission();
  };

/**
 * Checks the App Tracking Transparency status. Returns true if the user has granted permission (or if the app is not running on iOS),
 * false if not or if the status is not determined.
 */
export const checkAppTrackingTransparency = async (): Promise<boolean> => {
  // Check if the app is running on iOS, as App Tracking Transparency is an iOS feature
  if (!isIosApp()) {
    return true;
  }

  try {
    const response = await getAppTrackingStatus();
    if (response.status === 'notDetermined') {
      const requestResponse = await requestAppTrackingPermission();
      if (requestResponse.status !== 'authorized') {
        console.error(
          'App Tracking Transparency not authorized, no ads info to be gained.',
        );
        return false;
      }
      return requestResponse.status === 'authorized';
    }

    return response.status === 'authorized';
  } catch (error) {
    console.error('Error checking App Tracking Transparency', error);
    return false;
  }
};
